import { NbMenuItem } from '@nebular/theme';

export class MainMenuConfig {
  mainMenuItems: NbMenuItem[] = [
    {
      title: 'Status Pagina',
      icon: { icon: 'home', pack: 'eva' },
      link: '/status/facilities',
      hidden: true,
    },
    {
      title: 'Identifications',
      icon: { icon: 'ticket', pack: 'customIcons' },
      link: '/identification/validation',
      hidden: true,
    },
    {
      title: 'Transactions',
      icon: { icon: 'flip-2-outline', pack: 'eva' },
      link: '/transactions',
      hidden: true,
    },
    {
      title: 'Application Settings',
      icon: { icon: 'settings-outline', pack: 'eva' },
      link: '/settings',
      pathMatch: 'prefix',
      skipLocationChange: false,
      hidden: true,
    },
  ];
  loginMenuItems: NbMenuItem[] = [
    {
      title: 'Mijn Profiel',
      url: '/profile',
      icon: { icon: 'person', pack: 'eva' },
      pathMatch: 'prefix',
      skipLocationChange: false,
      hidden: false,
    },
  ];
  items = [
    { title: 'Mijn Profiel', link: '/profile' },
    { title: 'Uitloggen', link: 'account/logout' },
  ];
}
